export default __webpack_public_path__ + "static/media/logoSmall.76974b92.png";